import { render, staticRenderFns } from "./asset-list-item.vue?vue&type=template&id=070c9bcf&scoped=true&"
import script from "./asset-list-item.vue?vue&type=script&lang=ts&"
export * from "./asset-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./asset-list-item.vue?vue&type=style&index=0&id=070c9bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c9bcf",
  null
  
)

export default component.exports